import { SearchReefersByIdQuery } from '@/graphql/SearchReefersById.generated';

import { setSelectedRefrigerationUnitModels } from './refrigerationUnitModels';
import { store } from './store';

export type AssetSelectionItem =
  SearchReefersByIdQuery['container_insights_reefers'][0];

function setAssetSelection(assets: AssetSelectionItem[]) {
  store.selectedAssets = assets;
  setSelectedRefrigerationUnitModels(
    assets.map((asset) => asset.refrigeration_unit_model.id),
  );
}

function clearAssetSelection() {
  store.selectedAssets = [];
}

export { setAssetSelection, clearAssetSelection };
